/** The assistant only links divers to this marketplace, never model-supplied external sites. */
export function safeAssistantLink(value: string): string | null {
  try {
    const url = new URL(value, "https://www.beunderwater.com");
    if (url.protocol !== "https:" || !["www.beunderwater.com", "beunderwater.com"].includes(url.hostname) || url.port || url.username || url.password || url.pathname.startsWith("//")) return null;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch { return null; }
}
